/**
 * Горячие клавиши по умолчанию — одним списком на два места: окно по Ctrl+/
 * и «Систему» в настройках, как в Discord.
 */

/** На Mac вместо Ctrl — ⌘, как и в самих сочетаниях. */
const MOD = typeof navigator !== "undefined" && /Mac/i.test(navigator.platform) ? "⌘" : "Ctrl";

export const SHORTCUT_GROUPS: { title: string; keys: [string, string][] }[] = [
  {
    title: "Навигация",
    keys: [
      [`${MOD}+K`, "Быстрый переход"],
      [`${MOD}+I`, "Входящие"],
      ["Alt+↑ / ↓", "Соседний канал или переписка"],
      ["Alt+Shift+↑ / ↓", "Соседний непрочитанный канал"],
      [`${MOD}+Alt+Shift+↑ / ↓`, "Соседний канал с упоминанием"],
      [`${MOD}+Alt+↑ / ↓`, "Соседний сервер"],
      [`${MOD}+P`, "Закреплённые сообщения"],
      [`${MOD}+U`, "Список участников"],
      [`${MOD}+F`, "Поиск"],
      [`${MOD}+Shift+N`, "Создать сервер или вступить"],
      ["Alt+← / →", "Назад и вперёд по пройденному"],
      [`${MOD}+/`, "Горячие клавиши"],
    ],
  },
  {
    title: "Сообщения",
    keys: [
      ["Enter", "Отправить"],
      ["Shift+Enter", "Новая строка"],
      ["↑", "Изменить своё последнее — в пустом поле"],
      ["Esc", "Отменить ответ; иначе — канал прочитан"],
      ["Shift+Esc", "Прочитать весь сервер"],
      ["Shift+PageUp", "К первому непрочитанному"],
      ["Alt+щелчок", "Отметить непрочитанным"],
      [`${MOD}+E`, "Эмодзи"],
      [`${MOD}+S`, "Стикеры"],
      [`${MOD}+Shift+U`, "Загрузить файл"],
      ["Tab", "Следующий вариант подсказки"],
      ["/", "Встроенные команды — в начале поля"],
      ["Shift+щелчок", "Удалить без вопроса"],
    ],
  },
  {
    title: "Голосовое сообщение",
    keys: [
      ["Enter", "Отправить запись"],
      ["Esc", "Отменить запись"],
    ],
  },
  {
    title: "Звонок",
    keys: [
      [`${MOD}+Shift+M`, "Микрофон"],
      [`${MOD}+Shift+D`, "Звук"],
      [`${MOD}+'`, "Позвонить — в переписке"],
      [`${MOD}+Alt+A`, "К идущему звонку"],
      [`${MOD}+Enter`, "Принять входящий звонок"],
      ["Esc", "Отклонить входящий звонок"],
      ["Клавиша рации", "Говорить — в режиме «По кнопке»"],
      ["← / →", "Соседняя трансляция на сцене"],
    ],
  },
  {
    title: "Просмотр картинок",
    keys: [
      ["← / →", "Листать"],
      ["Esc", "Закрыть"],
    ],
  },
];

/** Группы сочетаний с клавишами в рамках. */
export function ShortcutList() {
  return (
    <div className="shortcuts">
      {SHORTCUT_GROUPS.map((group) => (
        <section key={group.title} className="shortcuts-group">
          <div className="caption">{group.title}</div>
          {group.keys.map(([keys, what]) => (
            <div key={keys + what} className="shortcuts-row">
              <span className="grow">{what}</span>
              <span className="shortcuts-keys">
                {keys.split(/(\+| \/ )/).map((part, index) =>
                  part === "+" || part === " / " ? (
                    <span key={index} className="shortcuts-sep">
                      {part.trim()}
                    </span>
                  ) : (
                    <kbd key={index}>{part}</kbd>
                  ),
                )}
              </span>
            </div>
          ))}
        </section>
      ))}
    </div>
  );
}
